var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanelControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 68.3333H6.6665V11.6666H73.3332V68.3333ZM9.99984 65H69.9998V15H9.99984V65ZM56.6665 28.3333H23.3332V18.3333H56.6665V28.3333ZM26.6665 25H53.3332V21.6666H26.6665V25ZM26.6665 35H13.3332V38.3333H26.6665V35ZM26.6665 45H13.3332V48.3333H26.6665V45ZM26.6665 55H13.3332V58.3333H26.6665V55ZM46.6665 35H33.3332V38.3333H46.6665V35ZM46.6665 45H33.3332V48.3333H46.6665V45ZM46.6665 55H33.3332V58.3333H46.6665V55ZM66.6665 35H53.3332V38.3333H66.6665V35ZM66.6665 45H53.3332V48.3333H66.6665V45ZM66.6665 55H53.3332V58.3333H66.6665V55Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelControl);
export default __webpack_public_path__ + "static/media/panel-control.cdeb400a9145d9af4d5a05f1518baec7.svg";
export { ForwardRef as ReactComponent };